export default __webpack_public_path__ + "static/media/blog-permeable-vs-concrete-003.969eec26.jpg";